/* EuroLab cart-fix v2 — key-based, single-path cart edits (replaces theme's racing AJAX + form submit). 2026-08-24 */
(function(){
  if (window.__eurolabCartFix) return; window.__eurolabCartFix = true;
  function busy(on){ document.querySelectorAll('[data-cart-form] .js-change-quantity, [data-cart-form] .cart__remove-btn').forEach(function(el){ el.style.pointerEvents = on ? 'none' : ''; el.style.opacity = on ? '0.5' : ''; }); }
  function keyFor(row){
    var k = row.getAttribute('data-line-key');
    if (k) return Promise.resolve(k);
    var vid = String(row.getAttribute('data-variant-id') || '');
    return fetch('/cart.js', {cache:'no-store'}).then(function(r){ return r.json(); }).then(function(c){
      for (var i = 0; i < c.items.length; i++) { if (String(c.items[i].variant_id) === vid) return c.items[i].key; }
      return null;
    });
  }
  function change(key, qty){
    if (!key) { window.location.href = '/cart'; return; }
    busy(true);
    fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id:key, quantity:qty }) })
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(){ busy(false); window.location.href = '/cart'; });
  }
  function row(el){ return el.closest('[data-cart-item]'); }
  document.addEventListener('click', function(e){
    var form = e.target.closest('[data-cart-form]');
    if (!form) return;
    var rm = e.target.closest('.cart__remove-btn');
    if (rm){
      e.preventDefault(); e.stopImmediatePropagation();
      var r = row(rm); if (!r) return;
      keyFor(r).then(function(k){ change(k, 0); });
      return;
    }
    var q = e.target.closest('.js-change-quantity');
    if (q){
      e.preventDefault(); e.stopImmediatePropagation();
      var r2 = row(q); if (!r2) return;
      var input = r2.querySelector('input.quantity');
      var cur = parseInt(input && input.value, 10); if (isNaN(cur)) cur = 1;
      var next = q.getAttribute('data-func') === 'plus' ? cur + 1 : cur - 1;
      if (next < 0) next = 0;
      keyFor(r2).then(function(k){ change(k, next); });
    }
  }, true);
  document.addEventListener('change', function(e){
    var input = e.target.closest('[data-cart-form] input.quantity'); if (!input) return;
    e.stopImmediatePropagation();
    var r = row(input); if (!r) return;
    var v = parseInt(input.value, 10); if (isNaN(v) || v < 0) v = 0;
    keyFor(r).then(function(k){ change(k, v); });
  }, true);
})();
